export function rebuildSplitPrefItems(list) {
    let out = [];
    let current = null;
    list.map(l => {
        if (current) {
            if (current.obj !== l.obj) {
                current = null;
            }
        }
        if (!current) { // @ts-ignore
            current = { obj: l.obj };
            out.push(current);
        }
        if (current === null)
            throw new Error("invalid state");
        let prop = current[l.type];
        if (!prop) {
            prop = { fromIndex: l.index === undefined ? -1 : l.index, toIndex: l.index === undefined ? -1 : l.index, slice: from => { if (!prop)
                    throw new Error("invalid state"); const fromIndex = prop.fromIndex === -1 ? 0 : prop.fromIndex; const toIndex = prop.toIndex === -1 ? from.length : prop.toIndex + 1; return from.slice(fromIndex, toIndex); } };
            current[l.type] = prop;
        }
        if (l.index !== undefined && prop.toIndex < l.index) {
            prop.toIndex = l.index;
        }
    });
    return out;
}
